module.exports = __webpack_public_path__ + "static/media/landing_course1.ed5eddf1.jpg";